/* eslint-disable react/prop-types */
import {
  Hidden,
  IconButton,
  InputAdornment,
  TextField,
  Toolbar,
  Zoom,
} from "@material-ui/core"
import withStyles from "@material-ui/core/styles/withStyles"
import CloseIcon from "@material-ui/icons/Close"
import SearchIcon from "@material-ui/icons/Search"
import update from "immutability-helper"
import React, { Fragment } from "react"
import ReactDOM from "react-dom"
import styles from "./styles"

class SearchControl extends React.Component {
  state = {
    previousSearch: "",
    value: this.props.value,
    searching: false,
    showMobileSearch: false,
  }

  handleChange = (e) => {
    const value = e.currentTarget.value
    this.setState(
      update(this.state, {
        value: {
          $set: value,
        },
      }),
    )
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (this.state.value) {
      if (this.state.value !== this.state.previousSearch) {
        this.props.onSearch(this.state.value)
      }
      this.setState(
        update(this.state, {
          searching: {
            $set: true,
          },
          previousSearch: {
            $set: this.state.value,
          },
        }),
      )
    }
  }

  handleClearSearch = (e) => {
    e.preventDefault()
    this.props.onSearch("")
    this.setState(
      update(this.state, {
        searching: {
          $set: false,
        },
        value: {
          $set: "",
        },
      }),
    )
  }

  renderSearchForm = () => {
    const { classes } = this.props
    return (
      <form onSubmit={this.handleSubmit} className={classes.form}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          value={this.state.value}
          onChange={this.handleChange}
          name="search"
          placeholder="Search"
          InputProps={{
            classes: {
              focused: classes.inputFocused,
              notchedOutline: classes.notchedOutline,
              adornedEnd: classes.adornedEnd,
            },
            endAdornment: (
              <InputAdornment
                className={classes.inputAdornment}
                position="start"
              >
                <Zoom in={this.state.searching}>
                  <IconButton
                    size="small"
                    className={classes.button}
                    type="button"
                    onClick={this.handleClearSearch}
                  >
                    <CloseIcon />
                  </IconButton>
                </Zoom>
                <Zoom in={!this.state.searching}>
                  <IconButton
                    size="small"
                    className={classes.button}
                    type="submit"
                  >
                    <SearchIcon />
                  </IconButton>
                </Zoom>
              </InputAdornment>
            ),
          }}
        />
      </form>
    )
  }

  handleShowMobileSearch = () => {
    this.setState({
      showMobileSearch: true,
    })
  }

  render() {
    const { classes } = this.props
    return (
      <Fragment>
        <Hidden smDown>
          <div className={classes.searchControl}>{this.renderSearchForm()}</div>
        </Hidden>
        <Hidden mdUp>
          <Fragment>
            <IconButton onClick={this.handleShowMobileSearch}>
              <SearchIcon />
            </IconButton>
            {this.state.showMobileSearch &&
              ReactDOM.createPortal(
                <Toolbar className={classes.mobileSearchToolbar}>
                  {this.renderSearchForm()}
                </Toolbar>,
                document.getElementById("mobile-search"),
              )}
          </Fragment>
        </Hidden>
      </Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true, name: "CAT" })(
  SearchControl,
)
